import AnswerFiles from './AnswerFiles.component';

export default AnswerFiles;